// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__64cmW","label":"Pill_label__OwMII"};